<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-user-plus"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة حجز ثالثة ثانوي</h1>
        <p class="form-page-header__subtitle">تسجيل طالب جديد في الصف الثالث الثانوي</p>
      </div>
    </div>

    <form @submit.prevent="sendForm()">
      <div class="form-card">
        <div class="form-card__header">
          <div class="form-card__header-icon"><i class="pi pi-id-card"></i></div>
          <span class="form-card__title">بيانات الطالب</span>
        </div>
        <div class="form-card__body">
          <div class="row g-4">
            <div class="col-lg-4 col-md-6 col-12">
              <div class="form-field">
                <label class="field-label" for="studentName">
                  اسم الطالب <span class="required">*</span>
                </label>
                <InputText id="studentName" v-model="student_name" placeholder="أدخل الاسم الكامل" class="w-100" />
                <span class="field-error" v-if="v$.student_name.$error">
                  <i class="pi pi-exclamation-circle"></i> برجاء ادخال اسم الطالب
                </span>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="form-field">
                <label class="field-label" for="studentPhone">رقم هاتف الطالب</label>
                <InputText id="studentPhone" v-model="student_phone" placeholder="01xxxxxxxxx" inputmode="tel" v-phone class="w-100" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="form-field">
                <label class="field-label" for="parentPhone">رقم هاتف ولي الأمر</label>
                <InputText id="parentPhone" v-model="parent_phone" placeholder="01xxxxxxxxx" inputmode="tel" v-phone class="w-100" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="form-field">
                <label class="field-label" for="gender">
                  الجنس <span class="required">*</span>
                </label>
                <Dropdown v-model="selected_gender" :options="genders" showClear optionLabel="name" placeholder="اختر الجنس" class="w-100" />
                <span class="field-error" v-if="v$.selected_gender.$error">
                  <i class="pi pi-exclamation-circle"></i> برجاء اختيار الجنس
                </span>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="form-field">
                <label class="field-label" for="type">
                  نظام التعليم <span class="optional">اختياري</span>
                </label>
                <Dropdown v-model="selected_type" :options="types" showClear optionLabel="name" placeholder="نظام التعليم" class="w-100" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="notice-box notice-box--warning mb-4">
        <i class="pi pi-whatsapp"></i>
        <span>
          اذا واجهتك اي مشكلة في الحجز بالرجاء التواصل مع رقم
          <a href="https://wa.me/+201111488849" target="_blank">01111488849</a> او
          <a href="https://wa.me/+201021631271" target="_blank">01021631271</a> على الواتساب
        </span>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn-submit" :disabled="formSending">
          <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
          <i class="pi pi-check" v-else></i>
          {{ formSending ? 'جاري الإرسال...' : 'حفظ الحجز' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Swal from 'sweetalert2';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Dropdown from 'primevue/dropdown';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
    name: "reservation-page",
    data() {
        return {
            v$: useVuelidate(),
            student_name: "",
            student_phone: null,
            parent_phone: null,
            address: "",
            math_degree: null,
            formSending: false,
            selected_gender: null,
            selected_type: null,
            genders: [
                { name: 'ولد', id: 1 },
                { name: 'بنت', id: 2 },
            ],
            types: [
                { name: 'عام', id: 1 },
                { name: 'أزهر', id: 2 },
            ],
            breadcrumbs: [
                { name: 'الرئيسية', path: '/' },
                { name: 'حجز ثالثة ثانوي', path: '/three_secondary' },
                { name: 'إضافة حجز ثالثة ثانوي', path: '/three_secondary/add' },
            ]

        }
    },
    components: {
        InputText,
        InputNumber,
        Dropdown,
        Breadcrumb
    },
    validations() {
        return {
            student_name: { required },
            //student_phone: { required },
            //parent_phone: { required },
            selected_gender: { required },
            //selected_type: { required },
        };
    },
    computed: {
        gradeStore() { return useGradeStore(); },
        gradeId() {
            const grade = this.gradeStore.allGrades.find(g => g.education_level_legacy == 6)
                || this.gradeStore.activeGrades.find(g => g.education_level_legacy == 6);
            return grade?.id ?? null;
        },
    },
    methods: {
        onlyNumbers(event) {
            // يمنع أي مفتاح غير رقم عربي أو إنجليزي
            const char = String.fromCharCode(event.which);
            // إذا ليس رقم، امنع الإدخال
            if (!/[0-9٠-٩]/.test(char)) {
                event.preventDefault();
                return;
            }
            // إذا الطول الحالي 11 رقم، امنع الإدخال
            const value = event.target.value;
            // احسب عدد الأرقام فقط (عربي أو إنجليزي)
            const digitsCount = (value.match(/[0-9٠-٩]/g) || []).length;
            if (digitsCount >= 11) {
                event.preventDefault();
            }
        },
        toEnglishDigits(str) {
            if (!str) return str;
            return str.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
        },
        sendForm() {
            this.v$.$validate();
            if (!this.v$.$error) {
                const formData = new FormData();
                formData.append('student_name', this.student_name);
                if(this.student_phone) {
                    formData.append('student_phone', this.toEnglishDigits(this.student_phone));
                }
                if(this.parent_phone) {
                    formData.append('parent_phone', this.toEnglishDigits(this.parent_phone));
                }
                if(this.selected_type != null) {
                  formData.append('education_type', this.selected_type.id);
                }                formData.append('gender', this.selected_gender.id);
                if (this.gradeId) formData.append('academic_year_id', this.gradeId);

                this.formSending = true;
                
                axios
                    .post('/register_dashboard', formData)
                    .then((response) => {
                        this.formSending = false;
                        this.resetForm();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الاضافه بنجاح",
                        });
                    })
                    .catch((error) => {
                        this.formSending = false;
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: error.response.data.message,
                        });
                    });
            }
        },
        resetForm() {
            this.v$.$reset();
            this.student_name = "";
            this.student_phone = null;
            this.parent_phone = null;
            this.selected_gender = null;
            this.selected_type = null;
        }
    },
    async mounted() {
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
    },
}
</script>
